{
  "top_label": "Chubb. Insured.",
  "buttons": [
    {
      "id": "policy-add-help",
      "label": "Help/FAQs",
      "iconName": "right-arrow"
    },
    {
      "id": "feedback",
      "label": "Feedback",
      "iconName": "right-arrow"
    }
  ],
  "footerTopSection": {
    "personalLines":{
      "label": "We’re here to help",
      "buttons": [
        {
          "id": "phone",
          "label": "(866) 324-8222 Option 1",
          "subText": "Mon - Fri 8am - 7pm ET",
          "type": "text",
          "cssClass": "phone-icon"
        },
        {
          "id": "email",
          "label": "Email",
          "iconPath": "icons/chevron-right-purple.svg",
          "type": "button",
          "cssClass": "email-icon"
        }
      ]
    },
    "businessLines":{
      "label": "We’re here to help",
      "sbAgent": "Small Business Agent",
      "buttons": [
        {
          "id": "phone",
          "label": "(866) 324-8222 Option 1",
          "subText": "Mon - Fri 8am - 7pm ET",
          "type": "text",
          "cssClass": "phone-icon"
        },
        {
          "id": "email",
          "label": "Email",
          "iconPath": "icons/chevron-right-purple.svg",
          "type": "button",
          "cssClass": "email-icon"
        }
      ],
      "otherLabel": "All other",
      "otherButtons": [
        {
          "id": "phone",
          "label": "(866) 324-8222 Option 1",
          "subText": "Mon - Fri 8am - 7pm ET",
          "type": "text",
          "cssClass": "phone-icon"
        },
        {
          "id": "email",
          "label": "Email",
          "iconPath": "icons/chevron-right-purple.svg",
          "type": "button",
          "cssClass": "email-icon"
        }
      ]
    }
    
  },
  "links": [
    {
      "id": "legal-notices",
      "type": "url",
      "target": "_self",
      "routeOrUrl": "https://www.chubb.com/us-en/terms-of-use.aspx",
      "label": "Legal Notices"
    },
    {
      "id": "privacy-policy",
      "type": "url",
      "target": "_self",
      "routeOrUrl": "https://www.chubb.com/us-en/online-privacy-policy.aspx",
      "label": "Privacy Policy"
    },
    {
      "id": "california-resident-notice",
      "type": "url",
      "target": "_self",
      "routeOrUrl": "https://www.chubb.com/us-en/_assets/doc/ccpa-at-collection-notice-all-categories-v1-2020.06.09.pdf",
      "label": "California Resident Notice"
    },
    {
      "id": "california-resident-privacy",
      "type": "url",
      "target": "_self",
      "routeOrUrl": "https://www.chubb.com/us-en/online-privacy-policy.aspx#CCPA-section",
      "label": "CA Privacy Policy"
    },
    {
      "id": "producer-compensation",
      "type": "url",
      "target": "_self",
      "routeOrUrl": "https://www.chubb.com/us-en/agents-brokers/Producer-Compensation.aspx",
      "label": "Producer Compensation"
    },
    {
      "id": "careers",
      "type": "url",
      "target": "_self",
      "routeOrUrl": "https://www.chubb.com/us-en/careers/",
      "label": "Careers"
    },
    {
      "id": "contact-us",
      "type": "url",
      "target": "_self",
      "routeOrUrl": "https://www.chubb.com/us-en/contact-us/contact-landing-page.aspx",
      "label": "Contact Us"
    }
  ]
}
